var map = {
	"./2024-10/Product.vue": [
		424793,
		24793
	],
	"./2024-11/Product.vue": [
		346490,
		46490
	],
	"./2024-12/Product.vue": [
		255324,
		55324
	],
	"./2025-01/Product.vue": [
		588625,
		88625
	],
	"./2025-03/Product.vue": [
		567415,
		67415
	],
	"./2025-04/Product.vue": [
		948239,
		48239
	],
	"./2025-05/Product.vue": [
		85808,
		85808
	],
	"./2025-06/Product.vue": [
		644463,
		44463
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 532776;
module.exports = webpackAsyncContext;